import { TextUI } from './Text';

export type TextButtonProps = {
  children: string
  onClick: () => void
};

export const TextButtonUI: React.FC<TextButtonProps> = ({ children, onClick }) => {
  return (
    <div onClick={onClick} style={{ cursor: 'pointer' }}>
      <TextUI color="grey" weight="bold">
        {children}
      </TextUI>
    </div>
  );
};
